const prefix = 'column-header-menu';

export const i18n = {
    ascending: {
        id: `${prefix}.ascending`,
        defaultMessage: 'Ascending',
    },
    descending: {
        id: `${prefix}.descending`,
        defaultMessage: 'Descending',
    },
    filterBy: {
        id: `${prefix}.filterBy`,
        defaultMessage: 'Filter by',
    },
    clearFilter: {
        id: `${prefix}.clearFilter`,
        defaultMessage: 'Clear filter',
    },
} as const;
